import { getState } from 'src/store';
import { currentSelectedSize } from './slice';

const getCurrentSize = () => {
  const state = getState();
  const res = currentSelectedSize()(state);
  return res;
};

export { getCurrentSize };
